export default "__VITE_ASSET__56be01b5__"